import { parse, format, isValid } from 'date-fns';

export const apiToDateObject = (dateString) => {
    if (!dateString) return null;
    let parsed = parse(dateString, 'yyyy-MM-dd', new Date());
    if (!isValid(parsed)) {
        parsed = parse(dateString, 'MM/dd/yyyy', new Date());
    }    
    return isValid(parsed) ? parsed : null;
};

export const dateObjectToApiFormat = (dateObj) => {
    if (!dateObj || !isValid(dateObj)) return '';
    return format(dateObj, 'yyyy-MM-dd'); 
};

export const transformToSelectOptions = (arr) => {
    if (!arr || !Array.isArray(arr)) return [];
    return arr.map(item => ({ value: item.lookupValue, label: item.lookupLabel }));
};

export const getNestedError = (errors, path) => path.split('.').reduce((obj, key) => (obj && obj[key] ? obj[key] : undefined), errors);